import { SCOPES } from '../api';
import type { NavNode } from '@nyce/admin-kit/console';
import { PRODUCTION_PATH } from './api/prodstats';

/** Production statistics (first in the Statistics group). */
export const PRODUCTION_NAV: NavNode[] = [
  {
    path: PRODUCTION_PATH,
    label: 'Production',
    requires: SCOPES.dbRead,
    description: 'Transactions, deliveries and shipment references per day across the nyce.logic databases.',
  },
];
